(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Cart functionality
  const cartForm = document.getElementById('cart-form');
  const quantityInputs = document.querySelectorAll('.quantity-input');
  const quantityButtons = document.querySelectorAll('.quantity-button');
  const removeButtons = document.querySelectorAll('.cart-item__remove');

  // Quantity button handlers
  quantityButtons.forEach(button => {
    button.addEventListener('click', function() {
      const change = parseInt(this.dataset.quantityChange);
      const line = this.dataset.line;
      const input = document.querySelector(`input[data-line="${line}"]`);

      if (input) {
        const currentValue = parseInt(input.value) || 0;
        const newValue = Math.max(0, currentValue + change);
        input.value = newValue;

        // Use cart/change.js for individual line items
        updateCartLine(line, newValue);
      }
    });
  });

  // Quantity input change handler
  quantityInputs.forEach(input => {
    input.addEventListener('change', function() {
      const value = parseInt(this.value) || 0;
      const line = this.dataset.line;

      if (value === 0) {
        removeCartItem(line);
      } else {
        this.value = value;
        updateCart();
      }
    });
  });

  // Remove button handlers
  removeButtons.forEach(button => {
    button.addEventListener('click', function() {
      const line = this.dataset.line;
      removeCartItem(line);
    });
  });

  function removeCartItem(line) {
    document.body.style.cursor = 'wait';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        line: parseInt(line),
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(cart => {
      // Reload the page to show updated cart
      window.location.reload();
    })
    .catch(error => {
      console.error('Error removing item:', error);
      document.body.style.cursor = 'default';
      alert('Error removing item. Please try again.');
    });
  }

  function updateCartLine(line, quantity) {
    document.body.style.cursor = 'wait';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        line: parseInt(line),
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(cart => {
      // Reload the page to show updated cart
      window.location.reload();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      document.body.style.cursor = 'default';
      window.location.reload();
    });
  }

  function updateCart() {
    // Fallback function for form submissions
    window.location.reload();
  }

  function updateCartDisplay(cart) {
    // Update cart count in header if it exists
    const cartCount = document.querySelector('.cart-count');
    if (cartCount) {
      cartCount.textContent = cart.item_count;
    }

    // Update subtotal
    const subtotal = document.querySelector('.cart-subtotal');
    if (subtotal) {
      subtotal.textContent = Shopify.formatMoney(cart.total_price);
    }

    // Update item totals
    cart.items.forEach((item, index) => {
      const lineTotal = document.querySelector(`[data-variant-id="${item.variant_id}"] .cart-item__total strong`);
      if (lineTotal) {
        lineTotal.textContent = Shopify.formatMoney(item.final_line_price);
      }
    });

    // If cart is empty, reload to show empty state
    if (cart.item_count === 0) {
      window.location.reload();
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Add form submission handling for filter changes
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('FacetFiltersForm');
    if (!form) return;

    // Handle checkbox changes
    form.addEventListener('change', function(event) {
      if (event.target.type === 'checkbox') {
        // Submit form on checkbox change
        submitFilters();
      }
    });

    // Handle price range inputs with debounce
    const priceInputs = form.querySelectorAll('input[type="number"]');
    let debounceTimer;
    priceInputs.forEach(input => {
      input.addEventListener('input', function() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          submitFilters();
        }, 1000);
      });
    });

    function submitFilters() {
      const formData = new FormData(form);
      const searchParams = new URLSearchParams(formData);

      // Build URL with filter parameters
      const url = `${window.location.pathname}?${searchParams}`;

      // Reload page with new filters
      window.location.href = url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const menuToggle = document.querySelector('.header__menu-toggle');
  const mobileMenu = document.querySelector('.header__mobile-menu');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileMenu.getAttribute('aria-hidden') === 'false';
      mobileMenu.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      menuToggle.setAttribute('aria-expanded', !isOpen);
      document.body.style.overflow = isOpen ? '' : 'hidden';
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Image gallery functionality
    const thumbnails = document.querySelectorAll('.product-media__thumbnail');
    const mainImage = document.querySelector('.product-media__image');

    if (thumbnails.length > 0 && mainImage) {
      thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', function() {
          // Update active thumbnail
          const activeThumbnail = document.querySelector('.product-media__thumbnail--active');
          if (activeThumbnail) {
            activeThumbnail.classList.remove('product-media__thumbnail--active');
          }
          this.classList.add('product-media__thumbnail--active');

          // Update main image
          const newImageUrl = this.dataset.imageUrl;
          if (newImageUrl) {
            mainImage.src = newImageUrl;
            mainImage.alt = this.querySelector('img').alt;
          }
        });
      });
    }

    // Quantity selector
    const quantityInput = document.querySelector('.product-form__quantity-input');
    const minusBtn = document.querySelector('[data-quantity-minus]');
    const plusBtn = document.querySelector('[data-quantity-plus]');

    if (minusBtn && plusBtn && quantityInput) {
      minusBtn.addEventListener('click', () => {
        const currentValue = parseInt(quantityInput.value) || 1;
        if (currentValue > 1) {
          quantityInput.value = currentValue - 1;
        }
      });

      plusBtn.addEventListener('click', () => {
        const currentValue = parseInt(quantityInput.value) || 1;
        quantityInput.value = currentValue + 1;
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
